<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.47 12.82">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_1074" data-name="Group 1074">
          <path
            id="Path_406"
            data-name="Path 406"
            class="cls-1"
            d="M4.48,0V5.49H11V0ZM9.37,2.06H6.11V1.37H9.37Z"
          />
          <g id="Group_1073" data-name="Group 1073">
            <path
              id="Path_407"
              data-name="Path 407"
              class="cls-1"
              d="M0,7.33v5.49H6.52V7.33ZM4.89,9.39H1.63V8.7H4.89Z"
            />
            <path
              id="Path_408"
              data-name="Path 408"
              class="cls-1"
              d="M9,7.33v5.49h6.51V7.33Zm4.89,2.06H10.59V8.7h3.26Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
